import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedListOfProduct, selectListProductState, setAction } from "../redux/slices/listOfProductsSlice"
import { ListOfProductsAPI } from "../apis/ListOfProductsAPI"
import { listOfProduct } from "../types/slices/listOfProductsType"

export const useListOfProductStore = () => {

    const dispatch = useDispatch()
    const { listOfProducts, listProductSelected, status, action } = useSelector(selectListProductState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getListOfProducts = async () => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ListOfProductsAPI.getListOfProducts()
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createListOfProduct = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ListOfProductsAPI.createListOfProduct(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editListOfProduct = async (idlist: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ListOfProductsAPI.editListOfProduct(idlist, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteListOfProduct = async (idlist: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ListOfProductsAPI.deleteListOfProduct(idlist)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedListProduct = (listOfProduct: listOfProduct) => {
        try {
            dispatch(onSetSelectedListOfProduct(listOfProduct))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionListProduct = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        listOfProducts,
        listProductSelected,
        status,
        action,
        //actions
        getListOfProducts,
        createListOfProduct,
        editListOfProduct,
        deleteListOfProduct,
        setSelectedListProduct,
        setActionListProduct,
    }
}